var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.homeMode === 'map')?_c('Map',{key:"home_map"}):(_vm.homeMode === 'mission')?_c('CorporateActivities',{key:"home_mission"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }